import React, { forwardRef } from 'react';

const Input = forwardRef(
  (
    {
      id = '',
      name = '',
      type = 'text',
      autoComplete = '',
      value = '',
      onChange = () => {},
      placeholder = 'Input Text',
      className = '',
      inputMode = '',
      pattern = '',
      disabled = false,
      onFocus = () => {},
      onBlur = () => {},
      onKeyDown = () => {},
    },
    ref
  ) => {
    return (
      <input
        ref={ref}
        id={id}
        name={name}
        type={type}
        autoComplete={autoComplete}
        onChange={onChange}
        value={value}
        inputMode={inputMode}
        pattern={pattern}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        disabled={disabled}
        className={`w-full py-1.5 px-2 rounded-md border focus:ring-1 focus:ring-blue-500 focus:outline-none ${className}`}
      />
    );
  }
);

export { Input };
export default Input;
